.overlay-close-button {
  align-items: center;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  display: inline-flex;
  height: 1.5rem;
  justify-content: center;
  position: absolute;
  right: 0.125rem;
  top: 0.125rem;
  transition: var(--transition-colors);
  width: 1.5rem;
}

.overlay-close-button:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.overlay-close-button:hover {
  background-color: var(--color-grey-300);
  cursor: pointer;
  outline: 0;
}

/* make the clickable area of the overlay close button 42x42px simmilar to a regular button */
.overlay-close-button::after {
  bottom: -0.625rem;
  content: " ";
  left: -0.625rem;
  position: absolute;
  right: -0.625rem;
  top: -0.625rem;
}

@media (min-width: 28rem) and (min-height: 28rem) {
  .overlay-close-button--padded {
    right: 1rem;
    top: 1rem;
  }
}
